import axios from 'axios';
import './index.sass';

export default () => {
    $(document).off('click', '.js-moderate-job').on('click', '.js-moderate-job', function (e) {
        e.preventDefault();
        const $this = $(this);

        axios.post($this.data('url'), {}, {
            headers: {
                'Accept': 'application/json',
                "X-CSRF-Token": $('meta[name=csrf-token]').attr('content')
            }
        }).then(({ data }) => {
            if (data.moderate) {
                $this.addClass('job-card__moderate--moderated')
            } else {
                $this.removeClass('job-card__moderate--moderated')
            }
        });
    });

    $(document).off('click', '.js-transfer-job').on('click', '.js-transfer-job', function (e) {
        e.preventDefault();
        const $this = $(this);

        axios.post($this.data('url'), {}, {
            headers: {
                'Accept': 'application/json',
                "X-CSRF-Token": $('meta[name=csrf-token]').attr('content')
            }
        }).then(({ data }) => {
            window.location.reload();
        });
    });
}
